import "./TableClass.scss";

import { FaSync } from "react-icons/fa";
import { FlagIcon } from "react-flag-kit";
import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import PlaceholderText from "../Placeholder/PlaceholderText";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import scheduleAllocation from "../../assets/images/img_class-multiple-classes-allocation.png";
import scheduleSequential from "../../assets/images/schedule/img_class-multiple-classes.png";
import { getConfirmClass, getNextClass, loadUserStorage, postConfirmClassRandom } from "../../store/middleware";

function RequestClass() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);
  const { totalPages, classesRequest } = useSelector((state) => state.teacherReducer);

  const [alertMsg, setAlertMsg] = useState("");
  const [alertImg, setAlertImg] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [alertTitle, setAlertTitle] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [alertItem, setAlertItem] = useState(null);
  const [alertClasses, setAlertClasses] = useState([]);
  const [openAlertTeacher, setOpenAlertTeacher] = useState(false);
  const [alertRecurrencyMsg, setAlertRecurrencyMsg] = useState("");

  const getRequested = async () => {
    setPageNumber(pageNumber + 1);
    await dispatch(getConfirmClass(user.teacherId, pageNumber + 1, true));
  };

  const acceptHandle = async (item) => {
    const {
      allocationSchedule,
      sequentialSchedule,
      allocationScheduleId,
      sequentialScheduleId,
      lingoLanguage: {
        flag,
        language: { name },
      },
    } = item;

    if (allocationSchedule === "fixed") {
      const classes = classesRequest
        .filter((item) => item.allocationScheduleId === allocationScheduleId)
        .map((item) => {
          return { flag, language: name, schedule: item.timeTotal };
        });

      const dayWeeks = classes.reduce((days, item) => {
        if (days && days.indexOf(item?.dayWeek) === -1) {
          return [...days, item?.dayWeek];
        } else {
          return [...days];
        }
      }, []);
      let recurrencyMsg = `
            ${t("REPEAT")}: ${dayWeeks.map((item) => t(item?.toUpperCase())).join(", ")}.
            ${t("UNTIL")} ${classes[classes.length - 1].time.format("DD/MM/YYYY")}
          `;

      if (classes.length > 1) {
        setOpenAlert(true);
        setAlertTitle("Fixed Scheduling");
        setAlertImg(scheduleAllocation);
        setAlertMsg("MULTYPLE_CLASSES_MESSAGE");
        setAlertItem(item);
        setAlertRecurrencyMsg(recurrencyMsg);
      } else {
        return acceptedHandle(item);
      }
    } else if (sequentialSchedule) {
      const alertClasses = classesRequest
        .filter((item) => item?.sequentialScheduleId === sequentialScheduleId)
        .map((item) => {
          return { flag, language: name, schedule: item?.timeTotal };
        });

      setOpenAlert(true);
      setAlertTitle("MULTYPLE_CLASSES");
      setAlertImg(scheduleSequential);
      setAlertMsg("MULTYPLE_CLASSES_MESSAGE");
      setAlertItem(item);
      setAlertClasses(alertClasses);
    } else {
      return acceptedHandle(item);
    }

    dispatch(loadUserStorage(true, true, "RequestClass"));
  };

  const acceptedHandle = async (item) => {
    const { sequentialScheduleId, allocationScheduleId, allocationSchedule } = item;

    setOpenAlert(false);
    if (allocationSchedule === "random") {
      await dispatch(postConfirmClassRandom(user.teacherId, sequentialScheduleId))
        .then(() => {})
        .catch((err) => {
          const errorMessage = err.response.data
            ? err.response.data.error_details
            : err.data.error.message[t("INDEX_KEY_ERROR")];

          setOpenAlertTeacher(true);
          setAlertMsg(errorMessage);
        });
    }
    if (allocationSchedule === "fixed") {
      await dispatch(postConfirmClassRandom(user.teacherId, allocationScheduleId))
        .then(() => {})
        .catch((err) => {
          const errorMessage = err.response.data
            ? err.response.data.error_details
            : err.data.error.message[t("INDEX_KEY_ERROR")];

          setOpenAlertTeacher(true);
          setAlertMsg(errorMessage);
        });
    }

    await dispatch(loadUserStorage(true, true, "RequestClass2"));
  };

  const closeAlert = () => {
    setOpenAlert(false);
  };

  const closeTeacher = () => {
    dispatch(getConfirmClass(user.teacherId, pageNumber));
    dispatch(getNextClass());
    setOpenAlert(false);
    setOpenAlertTeacher(false);
  };

  return (
    <div className="requestContainer">
      <div className="container">
        <div className="nextClass">
          <h2
            style={{
              paddingBottom: "10px",
              width: "99%",
              margin: "0 auto",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <span>
              <strong>{t("BTN_NEW_CLASS")}</strong> {t("BTN_REQUEST")}
            </span>{" "}
            <button className="buttonUpdate" onClick={() => dispatch(loadUserStorage(true, true, "RequestClass3"))}>
              <FaSync color="#004fff" />
              {t("UPDATE_SCREEN")}
            </button>
          </h2>
          {!classesRequest || !classesRequest.length ? (
            <PlaceholderText />
          ) : (
            <>
              <div
                style={{
                  overflowY: pageNumber === 1 ? "auto" : "scroll",
                  minHeight: "230px",
                  maxHeight: "600px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {classesRequest?.map((item, index) => {
                  return (
                    <div key={"i" + index} className="boxClass">
                      <div className="borderLeft" />
                      <div className="boxInfos">
                        <div className="date">
                          <h3>{item?.timeTotal}</h3>
                        </div>
                        <div className="infos">
                          <div className="classContent">
                            <h4>
                              <FlagIcon code={item?.lingoLanguage?.flag} />
                              {t(decryptIfEncrypted(item?.lingoLanguage?.language?.name).toUpperCase())}
                            </h4>
                            {item.classScheduleDetails.map((classDetails, i) => (
                              <div key={"cd" + i}>
                                <h4>
                                  {t("CARD_CLASS_CONTENT")}:
                                  <span
                                    className={classDetails.focus.toLowerCase() === "regular" ? "regular" : "specific"}
                                  >
                                    {t(classDetails.focus.toLowerCase() === "regular" ? "BTN_REGULAR" : "BTN_SPECIFIC")}
                                  </span>
                                  {item.type === "trial" && ` • ${t("TRIAL_CLASS")}`}
                                </h4>
                              </div>
                            ))}
                          </div>
                          <div className="status">
                            <button onClick={() => acceptHandle(item)} className="confirm">
                              {t("BTN_CONFIRM")} <i className="fa fa-check-circle-o" aria-hidden="true" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", paddingTop: "20px" }}>
                {totalPages === pageNumber ? (
                  <></>
                ) : (
                  <button
                    style={{
                      backgroundColor: "#fe0000",
                      borderRadius: "26px",
                      color: "#fff",
                      border: "none",
                      width: "40%",
                      height: "40px",
                      fontSize: "20px",
                      fontWeight: "500",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => getRequested(pageNumber)}
                  >
                    <span style={{ justifyContent: "center" }}>{t("LOAD_MORE")}</span>
                  </button>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      <Dialog open={openAlert} onClose={closeAlert} className="alert-dialog-slide">
        <DialogTitle className="alert-dialog-slide-title">{t(alertTitle?.toUpperCase())}</DialogTitle>
        <DialogContent className="alert-dialog-slide-content">
          <img src={alertImg} alt="schedule" />
          <p className="alert-dialog-text">{t(alertMsg?.toUpperCase())}</p>
          <hr />
          <div>
            {alertClasses.map(({ flag, language, schedule }) => (
              <div key={JSON.stringify(schedule)}>
                <p>
                  <FlagIcon code={flag} /> {`${t(language.toUpperCase())} ${schedule}`}
                </p>
              </div>
            ))}
          </div>
          <hr />
          {alertRecurrencyMsg && (
            <Fragment>
              <p className="alert-dialog-text-recurrency-message">{alertRecurrencyMsg}</p>
              <hr />
            </Fragment>
          )}
        </DialogContent>
        <DialogActions className="alert-dialog-slide-actions">
          <button className="new-button" onClick={() => setOpenAlert(false)}>
            {t("CANCEL")}
          </button>
          <button className="new-button" onClick={() => acceptedHandle(alertItem)} autoFocus>
            {t("ACCEPT_SEQUENCE")}
          </button>
        </DialogActions>
      </Dialog>

      <Dialog open={openAlertTeacher} onClose={() => closeTeacher()} className="alert-dialog-slide">
        <DialogTitle className="alert-dialog-slide-title">Erro!</DialogTitle>
        <DialogContent className="alert-dialog-slide-content">
          <p className="alert-dialog-text">{alertMsg}</p>
        </DialogContent>
        <DialogActions className="alert-dialog-slide-actions">
          <button className="new-button" onClick={() => closeTeacher()}>
            {t("OK")}
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default RequestClass;
